import * as React from 'react'
import { localizeDataQualityTypeName } from '../dataQualityWarnings/DataQualityType';
import { IndicatorGroupHeadingDiv, IndicatorAssetGroupDiv, IndicatorIndicatorsGroupDiv, CertificationIconWrapperStyle } from '../style/DataQualityIndicatorStyles';
import { DataQualityCertificationNonInteractiveIcon, DataQualityWarningNonInteractiveButton } from './DataQualityIndicatorButtons';
import { onThisAssetMessage, upstreamOfThisAssetMessage } from './DataQualityIndicatorFragments';
import { DataQualityDetailAuthorElement, DataQualityDetailAsset, DataQualityDetailChipId, DataQualityDetailDateElement, DataQualityDetailMessageElement, RenderIndicatorAssetProps, RenderIndicatorsProps } from './DataQualityIndicatorSharedHelpers';

function BigSpacer(): JSX.Element {
  return (<hr style={{
    borderColor: '#E6E6E6'
  }} />);
}

function RenderIndicators(props: Pick<RenderIndicatorAssetProps, 'assetName' | 'indicators'>): JSX.Element {
  return (
    <>
      {
        props.indicators.map((i, index) =>
          <React.Fragment key={index}>
            {
              i.kind === 'certification' ?
                <span style={{ display: 'flex', }}>
                  <CertificationIconWrapperStyle>

                    <DataQualityCertificationNonInteractiveIcon />
                  </CertificationIconWrapperStyle>
                  <DataQualityDetailAuthorElement {...i} />
                </span>
                :
                <>
                  <DataQualityWarningNonInteractiveButton
                    testId={DataQualityDetailChipId}
                    title={localizeDataQualityTypeName(i.type)}
                    warningKind={i.kind}
                  />
                  <DataQualityDetailAuthorElement {...i} />
                </>
            }
            <DataQualityDetailDateElement {...i} />
            <DataQualityDetailMessageElement {...i} assetName={props.assetName} />
          </React.Fragment>
        )
      }
    </>
  )
}

function RenderAnchoredAssetsIndicators(props: RenderIndicatorsProps): JSX.Element | null {
  if (props.indicators.length < 1) {
    return null;
  }

  return (
    <>
      <IndicatorGroupHeadingDiv>
        {onThisAssetMessage(props.assetType)}
      </IndicatorGroupHeadingDiv>
      <IndicatorAssetGroupDiv>
        <DataQualityDetailAsset
          assetName={props.assetName}
          assetType={props.assetType}
          assetUrl={props.linksDisabled ? null : props.assetUrl}
        />
        <IndicatorIndicatorsGroupDiv>
          <RenderIndicators assetName={props.assetName} indicators={props.indicators} />
        </IndicatorIndicatorsGroupDiv>
      </IndicatorAssetGroupDiv>
    </>
  )
}

export function RenderAssetsIndicators(props: RenderIndicatorsProps): JSX.Element | null {
  if (props.indicators.length < 1 && props.upstream.length < 1) {
    return null;
  }

  return (
    <>
      {
        props.indicators.length > 0 && <RenderAnchoredAssetsIndicators {...props} />

      }
      {
        props.indicators.length > 0 && props.upstream.length > 0 && <BigSpacer />
      }
      {
        props.upstream.length > 0 &&
        <>
          <IndicatorGroupHeadingDiv>
            {upstreamOfThisAssetMessage(props.assetType)}
          </IndicatorGroupHeadingDiv>
          <IndicatorAssetGroupDiv>
            {props.upstream.map(value =>
              <>
                <DataQualityDetailAsset
                  assetName={value.assetName}
                  assetType={value.assetType}
                  assetUrl={props.linksDisabled ? null : value.assetUrl}
                />
                <IndicatorIndicatorsGroupDiv>
                  <RenderIndicators assetName={value.assetName} indicators={value.indicators} />
                </IndicatorIndicatorsGroupDiv>
              </>
            )}
          </IndicatorAssetGroupDiv>
        </>
      }
    </>
  );
}
